// game id
import GameIds from '../../hub/data/GameIds';

export const GAME_ID = GameIds.FOOD_TRUCK_CHEFS_SPECIALS;

// app pages
export const APP_PAGES = {
  LOADING: 'loading',
  STANDARD: 'standard',
  PROGRESS: 'progress',
  LEVEL_SUMMARY: 'levelsummary',
  INSTRUCTION: 'instruction',
  ONBOARDING: 'onboarding',
  PRACTICE: 'practice',
};

// standard round statuses
export const STANDARD_ROUND_STATUSES = {
  STARTED: 'STANDARD_ROUND_STARTED',
  INTERRUPTED: 'STANDARD_ROUND_INTERRUPTED',
  COMPLETED: 'STANDARD_ROUND_COMPLETED',
};

// animations
export const ANIMATION_CORRECT_ANSWER_MS = 800;
export const ANIMATION_INCORRECT_ANSWER_MS = 1700;

// audios
export const INITIAL_AUDIO_DELAY_MS = 500;

// Alex states
export const ALEX_SILENT_STATE = 0;
export const ALEX_SPEAK_STATE = 1;

// standard round actions
export const SELECT_LEVEL = 'GOBLIN_GOURMET_SELECT_LEVEL';
export const INIT_STANDARD_ROUND = 'GOBLIN_GOURMET_INIT_STANDARD_ROUND';
export const NEXT_STANDARD_QUESTION = 'GOBLIN_GOURMET_NEXT_STANDARD_QUESTION';
export const COMPLETE_STANDARD_ROUND = 'GOBLIN_GOURMET_COMPLETE_STANDARD_ROUND';
export const INTERRUPT_STANDARD_ROUND = 'GOBLIN_GOURMET_INTERRUPT_STANDARD_ROUND';
export const RESET_ROUND_STATUS = 'GOBLIN_GOURMET_RESET_ROUND_STATUS';
export const MARK_PROGRESS = 'GOBLIN_GOURMET_MARK_PROGRESS';
export const UPDATE_RECORDS = 'GOBLIN_GOURMET_UPDATE_RECORDS';

// audio sequence actions
export const INIT_SEQUENCE = 'GOBLIN_GOURMET_INIT_SEQUENCE';

// goblin actions
export const INIT_GOBLINS_LINE = 'GOBLIN_GOURMET_INIT_GOBLINS_LINE';
export const MOVE_GOBLINS_LINE = 'GOBLIN_GOURMET_MOVE_GOBLINS_LINE';
export const GOBLIN_IDLE = 'GOBLIN_GOURMET_GOBLIN_IDLE';
export const GOBLIN_WRONGORDER = 'GOBLIN_GOURMET_GOBLIN_WRONGORDER';
export const GOBLIN_YUM = 'GOBLIN_GOURMET_GOBLIN_YUM';

// navigator actions
export const LOAD_PROGRESS_PAGE = 'GOBLIN_GOURMET_LOAD_PROGRESS_PAGE';
export const LOAD_LEVEL_SUMMARY_PAGE = 'GOBLIN_GOURMET_LOAD_LEVEL_SUMMARY_PAGE';
export const LOAD_ONBOARDING_PAGE = 'GOBLIN_GOURMET_LOAD_ONBOARDING_PAGE';
export const LOAD_STANDARD_PAGE = 'GOBLIN_GOURMET_LOAD_STANDARD_PAGE';
export const LOAD_INSTRUCTION_PAGE = 'GOBLIN_GOURMET_LOAD_INSTRUCTION_PAGE';
export const LOAD_LOADING_PAGE = 'GOBLIN_GOURMET_LOAD_LOADING_PAGE';
export const LOAD_PRACTICE_PAGE = 'GOBLIN_GOURMET_LOAD_PRACTICE_PAGE';

// animation and dropzone actions
export const INIT_DROP_ZONE_LAYOUT = 'GOBLIN_GOURMET_INIT_DROP_ZONE_LAYOUT';
export const TURN_DROP_ZONE_ON = 'GOBLIN_GOURMET_TURN_DROP_ZONE_ON';
export const TURN_DROP_ZONE_OFF = 'GOBLIN_GOURMET_TURN_DROP_ZONE_OFF';

export const TURN_ANIMATED_KNIFE_ON = 'GOBLIN_GOURMET_TURN_ANIMATED_KNIFE_ON';
export const TURN_ANIMATED_KNIFE_OFF = 'GOBLIN_GOURMET_TURN_ANIMATED_KNIFE_OFF';
export const TURN_TILE_ANIMATION_ON = 'GOBLIN_GOURMET_TURN_TILE_ANIMATION_ON';
export const TURN_TILE_ANIMATION_OFF = 'GOBLIN_GOURMET_TURN_TILE_ANIMATION_OFF';
export const SWITCH_ONBOARDING_TILE_ANIMATION = 'GOBLIN_GOURMET_SWITCH_ONBOARDING_TILE_ANIMATION';

// question actions
export const INIT_TRAY = 'GOBLIN_GOURMET_INIT_TRAY';
export const RELOAD_TRAY = 'GOBLIN_GOURMET_RELOAD_TRAY';
export const ADD_TILE_TO_DESK = 'GOBLIN_GOURMET_ADD_TILE_TO_DESK';
export const REMOVE_TILE_FROM_DESK = 'GOBLIN_GOURMET_REMOVE_TILE_FROM_DESK';
export const REORDER_TILES_ON_DESK = 'GOBLIN_GOURMET_REORDER_TILES_ON_DESK';
export const CUT_TILE = 'GOBLIN_GOURMET_CUT_TILE';
export const SERVE_ANSWER = 'GOBLIN_GOURMET_SERVE_ANSWER';
export const SERVE_PRACTICE_ANSWER = 'GOBLIN_GOURMET_SERVE_PRACTICE_ANSWER';
export const TURN_SECOND_ATTEMPT_MODE_ON = 'GOBLIN_GOURMET_TURN_SECOND_ATTEMPT_MODE_ON';
export const TURN_TRY_AGAIN_MODE_ON = 'TURN_TRY_AGAIN_MODE_ON';
export const TURN_FINAL_FEEDBACK_MODE_ON = 'GOBLIN_GOURMET_TURN_FINAL_FEEDBACK_MODE_ON';

// Alex actions
export const ALEX_SPEAK = 'GOBLIN_GOURMET_ALEX_SPEAK';
export const ALEX_SILENT = 'GOBLIN_GOURMET_ALEX_SILENT';

// game details actions
export const UPDATE_GAME_PRACTICE_DETAILS = 'GOBLIN_GOURMET_UPDATE_GAME_PRACTICE_DETAILS';
export const UPDATE_GAME_ONBOARDING_DETAILS = 'GOBLIN_GOURMET_UPDATE_GAME_ONBOARDING_DETAILS';

// metadata constants
export const NUM_LEVELS = 23;
export const LAST_AVAILABLE_LEVEL_ID = 22;

// amount of correct answers user needs to give in order to become mastered for level
export const MASTERED_LEVEL_THRESHOLD = 6;
export const QUESTIONS_PER_ROUND = 8;

// max amount of letters on the desk
export const DESK_WEIGHT_LIMIT = 20;

// array with goblins ids
export const GOBLINS_IDS = [1, 2, 3, 4, 5];

// goblin animation keys
export const GOBLIN_ANIMATION_KEYS = {
  IDLE: 'GOBLIN_IDLE',
  YUM: 'GOBLIN_YUM',
  WRONGORDER: 'GOBLIN_WRONGORDER',
};

// drop zone keys
export const DROP_ZONE_KEYS = {
  DESK: 'DESK',
  LEFT_TRAY: 'LEFT_TRAY',
  RIGHT_TRAY: 'RIGHT_TRAY',
};
